<template src="./Brand.html"></template>

<script>
import axios from 'axios'

const c3 = require('c3')
const d3 = require('d3')

import Back from '@/components/Dashboard/Back'
import Searchfield from '@/components/Dashboard/Searchfield'
import Settings from '@/components/Dashboard/Settings'
import Years from '@/components/Dashboard/Years'

export default {
  name: 'brand',
  components: { Back, Searchfield, Settings, Years },
  data () {
    return {
      years: [],
      year: '',
      showmore: false,
      sort: 'revenues',
      showEG: 0,
      yearslink: '/dashboard/statistics/brands/' + this.year
    }
  },
  mounted: function() {
    const date = new Date()
    this.year = date.getFullYear()

    this.fetchData()
  },
  watch: {
    
  },
  beforeRouteUpdate (to, from, next) {
    
  },
  methods: {    
    format: function(value) {      
      var me = this;
      d3.formatDefaultLocale(
      {
        "decimal": ",",
        "thousands": ",",
        "grouping": [3],
        "currency": ["", "€"]
      }
      );
      //return d3.format("$,")(value);
    },
    fetchData: function() {
      this.$parent.loader = 1
      
      var url = this.$serviceurl + 'statistik/jahresumsaetze/kunde/' + localStorage.getItem('ext-kunde');
      let headers = { 
        'Access-Control-Allow-Origin': '*', 
        'Accept': 'application/json', 
        'app-version': '2.2', 
        'token' : localStorage.getItem('ext-token') 
      };
      let options = { 
        headers: headers
      };

      axios.get(url + '?token=' + localStorage.getItem('ext-token') + '&sort=' + this.sort + '&jahr=' + this.year, options).then(response => {
        /*this.years = response.data;*/        
        this.setYears(response.data)
        localStorage.setItem('years',response.data)
        this.drawChart()
        this.$parent.loader = 0
      })
      .catch(e => {
        //console.log(e)
      })
    },
    drawChart: function(update) {
      var me = this;
      if(update) {
        setTimeout(function () {
          var aY = [
            ['WQ'],
            ['GQ']
          ];     
          if(me.showEG==1)aY.push(['GSP'])
          for(var i=0; i < me.years[0].length; i++) {
            aY[0].push('' + me.years[0][i].webQuote + '')
            aY[1].push(me.years[0][i].gutschriftenQuote)
            if(me.showEG==1)aY[2].push(me.years[0][i].gewinnSpanne)
          }
          if(me.showEG==1) {
            var cols = [
                aY[0],
                aY[1],
                aY[2],
                //['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
                //['Umsatz', this.years[0][3].umsatz, this.years[0][2].umsatz, this.years[0][1].umsatz, this.years[0][0].umsatz],
                //['Erloes', this.years[0][3].erloes, this.years[0][2].erloes, this.years[0][1].erloes, this.years[0][0].erloes],              
            ]
          } else {
            var cols = [
                aY[0],
                aY[1],
                //aY[2],
                //['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
                //['Umsatz', this.years[0][3].umsatz, this.years[0][2].umsatz, this.years[0][1].umsatz, this.years[0][0].umsatz],
                //['Erloes', this.years[0][3].erloes, this.years[0][2].erloes, this.years[0][1].erloes, this.years[0][0].erloes],              
            ]
          }
          chart.load({
              columns: cols,
              /*[
                ['GSP', me.years[0][3].gewinnSpanne, me.years[0][2].gewinnSpanne, me.years[0][1].gewinnSpanne, me.years[0][0].gewinnSpanne],
                ['WQ', me.years[0][3].webQuote, me.years[0][2].webQuote, me.years[0][1].webQuote, me.years[0][0].webQuote],
                ['GQ', me.years[0][3].gutschriftenQuote, me.years[0][2].gutschriftenQuote, me.years[0][1].gutschriftenQuote, me.years[0][0].gutschriftenQuote],
              ],*/
              unload: ['Umsatz', 'Erloes'],
          });
        },0);
        
      }

      var aY = [
        ['x'],
        ['Umsatz']
      ];     
      if(this.showEG==1)aY.push(['Erloes'])

      for(var i=0; i < this.years[0].length; i++) {
        aY[0].push('' + this.years[0][i].jahr + '')
        aY[1].push(this.years[0][i].umsatz)
        if(this.showEG==1)aY[2].push(this.years[0][i].erloes)
      }      

      if(this.showEG==1) {
        var cols = [
            aY[0],
            aY[1],
            aY[2],
            //['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
            //['Umsatz', this.years[0][3].umsatz, this.years[0][2].umsatz, this.years[0][1].umsatz, this.years[0][0].umsatz],
            //['Erloes', this.years[0][3].erloes, this.years[0][2].erloes, this.years[0][1].erloes, this.years[0][0].erloes],              
        ]
      } else {
        var cols = [
            aY[0],
            aY[1],
            //aY[2],
            //['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
            //['Umsatz', this.years[0][3].umsatz, this.years[0][2].umsatz, this.years[0][1].umsatz, this.years[0][0].umsatz],
            //['Erloes', this.years[0][3].erloes, this.years[0][2].erloes, this.years[0][1].erloes, this.years[0][0].erloes],              
        ]
      }

      this.format();

      var chart = c3.generate({
        bindto: '#yCustomerChart',
        size: {
            height: 240
        },
        padding: {
            //top: 40,
            right: 30,
            //bottom: 40,
            //left: 100,
        },
        color: {
            pattern: ['blue', 'green', 'orange']
        },
        data: {
          x: 'x',
            xFormat: '%Y', // 'xFormat' can be used as custom format of 'x'
          columns: cols
          /*[
              aY[0],
              aY[1],
              aY[2],
              //['x', '2014', '2015', '2016', '2017'],
              //['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
              //['Umsatz', this.years[0][3].umsatz, this.years[0][2].umsatz, this.years[0][1].umsatz, this.years[0][0].umsatz],
              //['Erloes', this.years[0][3].erloes, this.years[0][2].erloes, this.years[0][1].erloes, this.years[0][0].erloes],              
          ]*/
        },
        axis: {
          x: {
              type: 'timeseries',
              tick: {
                  format: '%Y'
              }
          },
          y: {
            tick: {
              format: d3.format("$,")
            }
          },
        },
        tooltip: {
            format: {
                //title: function (d) { return 'Data ' + d; },
                value: function (value, ratio, id) {
                    var format = d3.format(',');
                    return format(value);
                }
    //            value: d3.format(',') // apply this format to both y and y2
            }
        }
      })
    },
    /*
    drawChart: function() {
      var chart = c3.generate({
        bindto: '#yCustomerChart',
        size: {
            height: 240
        },
        padding: {
            //top: 40,
            right: 30,
            //bottom: 40,
            //left: 100,
        },
        color: {
            pattern: ['blue', 'green', 'lila', 'orange']
        },
        data: {
          x: 'x',
            xFormat: '%Y', // 'xFormat' can be used as custom format of 'x'
          columns: [
              ['x', '2014', '2015', '2016', '2017'],
              //['x', '20130101', '20130102', '20130103', '20130104', '20130105', '20130106'],
              ['Umsatz', this.years[0][3].umsatz, this.years[0][2].umsatz, this.years[0][1].umsatz, this.years[0][0].umsatz],
              ['Erloes', this.years[0][3].erloes, this.years[0][2].erloes, this.years[0][1].erloes, this.years[0][0].erloes],
              ['GSP', this.years[0][3].gewinnSpanne, this.years[0][2].gewinnSpanne, this.years[0][1].gewinnSpanne, this.years[0][0].gewinnSpanne],
              ['WQ', this.years[0][3].webQuote, this.years[0][2].webQuote, this.years[0][1].webQuote, this.years[0][0].webQuote],
          ]
        },
        axis: {
            x: {
                type: 'timeseries',
                tick: {
                    format: '%Y'
                }
            }
        }
      })
    },
    */
    setYears: function(data) {
      var asc = []
      var desc = []
      for(var i = 0;i < data.length;i++) {
        asc[i] = data[i]
        desc[i] = data[i]
      }
      desc = desc.reverse()
      this.years.push(asc)
      this.years.push(desc)

      this.$parent.years = this.years
    },
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    },
    setName(type,value) {
      this.$parent.setName(type,value)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Brand.vue?ccd27430